
<style scoped>
/* Estilos para el botón de añadir más archivos */
.add-file-input-button {
  padding: 8px 15px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 15px;
  margin-bottom: 20px;
}

.add-file-input-button:hover {
  background-color: #218838;
}

/* Mantén otros estilos de tu formulario principal aquí */
</style>
<template>
  	<div>
    	<app-overlay-loader v-if="preloader" />
		<form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">      
			<div v-if="existingFiles.length > 0 || filesToDelete.length > 0">
				<h4>Existing Files</h4>
				<div v-for="fileData in existingFiles" :key="fileData.name">
					<FileInput
						v-if="!filesToDelete.includes(fileData.name)"
						label-text=""
						:initial-file="fileData"
						:file-data="fileData" :accepted-types="acceptedTypes"
						@file-cleared="handleExistingFileCleared"
						@remove-input="handleExistingFileRemoved"
						@file-selected="handleNewFileReplacedExisting"
						:is_read = true
					/>
				</div>
			</div>

			<div class="row">
				<div class="col-md-6">
					<button type="button" class="btn btn-primary mr-2 w-100" 
						@click="redirectToRevision">
						{{ $t('next') }}
					</button>
				</div>
			</div>
		</form>
  	</div>
</template>

<script>
import FileInput from './../components/imports/FileInput.vue';

export default {
  	name: 'ImportDocuments',
  	components: { 
    	FileInput,
  	},
  	data() {
    	return {
      		preloader: false,
      		contractNumber: null,
      		acceptedTypes: '*', 
      		existingFiles: [], 
      		newFileInputs: [], 
      		filesToDelete: [], 
      		nextNewInputId: 1, 
    	};
  	},
  	created() {
		const contract = JSON.parse(localStorage.getItem('DataContractMaster'));
		this.contractNumber = contract.contractNumber;
		if (this.contractNumber) {
			this.fetchExistingFiles();
		}

		if (this.newFileInputs.length === 0 && this.existingFiles.length === 0) {
			this.addNewFileInput();
		}
  	},
  	methods: {
    async fetchExistingFiles() {
      	this.preloader = true;
      	try {
	        const response = await axios.get(`/api/contracts/${this.contractNumber}/files`);
        	this.existingFiles = response.data.files.map(fileName => ({ name: fileName }));
        	if (this.existingFiles.length === 0) { // <- si el contrato no tiene archivo agrega un input vacío
            	this.addNewFileInput();
        	}
      	} catch (error) {
        	console.error("Error al obtener la lista de archivos existentes:", error);
      	} finally {
        	this.preloader = false;
      	}
    },

    addNewFileInput() {
      	this.newFileInputs.push({
        	id: this.nextNewInputId++,
        	labelText: `Seleccionar Archivo Adicional ${this.newFileInputs.length + 1}`,
        	file: null,
        	replaces: null 
      	});
    },

    handleNewFileInputSelected(data, index) {
      	this.newFileInputs[index].file = data.file;
    },

    handleNewFileInputCleared(index) {
      	this.newFileInputs[index].file = null;
    },

    removeNewFileInput(index) {
      this.newFileInputs.splice(index, 1);
    },

    handleExistingFileCleared(fileData) {
        if (fileData && fileData.name && !this.filesToDelete.includes(fileData.name)) {
            this.filesToDelete.push(fileData.name);
            console.log("Marked for deletion:", fileData.name);
        }
    },
    
    handleExistingFileRemoved(fileData) {
        this.handleExistingFileCleared(fileData);
    },


    handleNewFileReplacedExisting(data) {
        const { file, originalData } = data;
        if (originalData && originalData.name && !this.filesToDelete.includes(originalData.name)) {
            this.filesToDelete.push(originalData.name);
            console.log("Original marcado para reemplazar/eliminar:", originalData.name);
        }
        this.newFileInputs.push({
            id: this.nextNewInputId++,
            labelText: `Reemplazo de ${originalData.name}`, 
            file: file,
            replaces: originalData.name 
        });
        this.existingFiles = this.existingFiles.filter(f => f.name !== originalData.name);
    },

    async submitForm() {
      this.preloader = true;
      try {
        const formData = new FormData();
        formData.append("contractNumber", this.contractNumber); 

        this.newFileInputs.forEach((input, index) => {
          	if (input.file) {
            	formData.append(`uploadedFile_${index}`, input.file);
				if (input.replaces) {
					formData.append(`replacesFile_${index}`, input.replaces);
				}
          	}
        });

        if (this.filesToDelete.length > 0) {
          	formData.append('filesToDelete', JSON.stringify(this.filesToDelete));
        }

        const url = `/api/contracts/${this.contractNumber}/update-files`; 
        const response = await axios.post(url, formData);

        console.log("Operación completada:", response.data);
        this.fetchExistingFiles(); // Vuelve a cargar la lista de archivos para refrescar
        this.filesToDelete = []; // Limpia la lista de eliminados
        this.newFileInputs = []; // Limpia los nuevos inputs
        this.addNewFileInput(); // Y agrega uno vacío para nuevas subidas
      	} catch (error) {
        	console.error("Error en la operación del contrato:", error);
      	} finally {
        	this.preloader = false;
      	}
    },

	async redirectToRevision() {
		await this.submitForm();
		this.redirected = true;
		this.$router.push({
			name: 'revision',
			query: { 'tab': 'revision' },
			params: { id: this.contractId }
		});
    },
  },

  	
};
</script>
